import { GlobalEnumerationsAceMittelabruf } from "@/api/model-index";
import { StammdatenService } from "@/core/services/stammdaten.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, createUrlTreeFromSnapshot } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class PaymentGuard  {
    constructor(protected readonly router: Router, protected readonly stammdatenService: StammdatenService) {
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const portalkonfiguration = await this.stammdatenService.GetPortalKonfiguration().toPromise();

        switch (portalkonfiguration && portalkonfiguration.artDesMittelabrufs) {
            case GlobalEnumerationsAceMittelabruf.Forderbetrag:
                this.router.navigateByUrl(createUrlTreeFromSnapshot(route, ["../funding-amount"]));
                return true;
            case GlobalEnumerationsAceMittelabruf.Zahlung:
                return true;
        }
        this.router.navigate(["/"]);
        return true;
    }
}